// extracted by mini-css-extract-plugin
module.exports = {"wrap":"fe","heading":"ge","items":"he","featureCss":"ie","disabled":"je","imgCss":"ke"};